/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { TimeTrialCto } from '../../models/time-trial-cto';
import { TimeTrialExtensionRequestCto } from '../../models/time-trial-extension-request-cto';

export interface ExtendCompanyTimeTrial$Json$Params {
  companyId: string;
      body?: TimeTrialExtensionRequestCto
}

export function extendCompanyTimeTrial$Json(http: HttpClient, rootUrl: string, params: ExtendCompanyTimeTrial$Json$Params, context?: HttpContext): Observable<StrictHttpResponse<TimeTrialCto>> {
  const rb = new RequestBuilder(rootUrl, extendCompanyTimeTrial$Json.PATH, 'post');
  if (params) {
    rb.path('companyId', params.companyId, {});
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<TimeTrialCto>;
    })
  );
}

extendCompanyTimeTrial$Json.PATH = '/company/{companyId}/extendtimetrial';
